import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'video.js/dist/video-js.css';

import proc from 'process/browser.js';

import { defaultColor } from './constants/defaultValues';
import { setCurrentColor } from './helpers/Utils';

const color = defaultColor;

setCurrentColor(color);

const render = () => {
  import(`./assets/css/sass/themes/gogo.${color}.scss`).then(() => {
    require('./AppRenderer');
  });
};

render();
// Ensure a robust global process object for vendor libraries
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = proc;
  window.process.env = window.process.env || {};
  window.process.env.NODE_ENV = window.process.env.NODE_ENV || 'development';
}
